import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PricingCards, PlanId } from './PricingCards';
export function FinalCTA() {
  const [selectedPlan, setSelectedPlan] = useState<PlanId>('kitpro');
  return <section className="py-14 md:py-20 bg-background relative" data-id="element-69">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[300px] md:h-[400px] bg-primary/5 blur-[100px] rounded-full pointer-events-none" data-id="element-70" />

      <div className="container mx-auto px-5 md:px-6 relative z-10" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-6 md:mb-8" data-id="element-72">
          <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3 md:mb-4 text-balance" data-id="element-73">
            DEJÁ DE MANEJAR TU NEGOCIO{' '}
            <span className="text-primary italic" data-id="element-74">A CIEGAS</span>
          </h2>
          <p className="text-sm md:text-lg text-text-muted mb-4 md:mb-5" data-id="element-75">
            Cada día que pasa sin controlar tus finanzas es un día más tomando
            decisiones sin información.
          </p>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-surface border border-surface-light" data-id="element-76">
            <span className="text-sm" data-id="element-77">🔥</span>
            <span className="text-[10px] md:text-xs font-bold tracking-wide text-primary-light uppercase" data-id="element-78">
              Oferta de lanzamiento — Acceso inmediato
            </span>
          </div>
        </motion.div>

        <PricingCards selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} data-id="element-79" />

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-8 md:mt-10 text-center" data-id="element-80">
          <p className="text-lg md:text-xl font-serif text-white" data-id="element-81">
            EMPEZÁ HOY MISMO
          </p>
        </motion.div>
      </div>
    </section>;
}